<template>
  <Message v-if="props.errors" severity="error">
    <template v-if="props.errors instanceof Array">
      <div v-for="error of props.errors">
        {{ error }}
      </div>
    </template>
    <template v-else>
      {{ props.errors }}
    </template>
  </Message>
</template>

<script setup lang="ts">
import Message from "primevue/message";
const props = defineProps<{
  errors?: object | string[];
}>();
</script>

<style scoped></style>
